import { DialogContent, DialogTitle } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { BoundTextField } from "lib/@components/binding/bound-components"

export function FentraUserDialog({ mode = "create", user }) {
    const isEdit = mode === "edit"
    const initialValue = isEdit
        ? {
              userName: user?.userName ?? "",
              givenName: user?.givenName ?? "",
              familyName: user?.familyName ?? "",
              displayName: user?.displayName ?? "",
              email: user?.email ?? "",
              jobTitle: user?.jobTitle ?? "",
          }
        : {}

    return (
        <DataInputDialog initialValue={initialValue}>
            <DialogTitle>{isEdit ? "Edit User" : "Add User"}</DialogTitle>
            <DialogContent>
                {/* userName is used as the SCIM userName claim — typically an email address */}
                <BoundTextField
                    field="userName"
                    label="Username (SCIM userName)"
                    fullWidth
                    sx={{ mb: 2, mt: 1 }}
                    yup="string.trim.required"
                />
                <BoundTextField field="givenName" label="Given Name" fullWidth sx={{ mb: 2 }} />
                <BoundTextField field="familyName" label="Family Name" fullWidth sx={{ mb: 2 }} />
                <BoundTextField field="displayName" label="Display Name" fullWidth sx={{ mb: 2 }} />
                <BoundTextField field="email" label="Email" fullWidth sx={{ mb: 2 }} yup="string.trim.email" />
                <BoundTextField field="jobTitle" label="Job Title" fullWidth sx={{ mb: 1 }} />
            </DialogContent>
        </DataInputDialog>
    )
}
